export const PRICING_DISCLAIMER =
  "Pricing shown is indicative for the MVP and may change based on portfolio size, users, integrations, governance requirements and deployment model.";

export const PLANS = [
  {
    id: "demo",
    title: "Demo",
    price: "Free",
    subtitle: "Explore the YUG360-MIND modernization journey.",
    features: [
      "Guided APP-042 modernization demo",
      "WHY assessment",
      "Evidence review",
      "7R decision journey",
      "MDR and governance walkthrough",
      "Expected vs Actual value demonstration",
    ],
    cta: "Explore Demo",
    ctaTo: "/login?demo=1",
    ctaTestId: "pricing-cta-demo",
    analytics: "demo_clicked",
    highlight: false,
  },
  {
    id: "trial",
    title: "14-Day Trial",
    price: "Start Free",
    afterPrice: "Starting from ₹9,999/month",
    features: [
      "1 customer workspace",
      "Up to 25 applications",
      "Application portfolio management",
      "WHY assessment",
      "Evidence management",
      "7R modernization assessment",
      "Modernization Decision Records",
      "Core governance workflow",
    ],
    cta: "Start Free Trial",
    ctaTo: "/signup?plan=trial",
    ctaTestId: "pricing-cta-trial",
    analytics: "trial_started",
    highlight: false,
  },
  {
    id: "professional",
    title: "Professional",
    price: "Starting from ₹29,999/month",
    badge: "Most Popular",
    features: [
      "Up to 250 applications",
      "Multiple workspace users",
      "Evidence-driven modernization assessment",
      "Explainable 7R alternatives",
      "MDR governance",
      "G1–G8 governance journey",
      "Deployment and hypercare tracking",
      "Expected vs Actual TCO/ROI reporting",
      "Portfolio-level governance",
    ],
    cta: "Request Professional Access",
    ctaTo: "/signup?plan=professional",
    ctaTestId: "pricing-cta-professional",
    analytics: "professional_requested",
    highlight: true,
  },
  {
    id: "enterprise",
    title: "Enterprise",
    price: "Custom",
    features: [
      "Large application estates",
      "Enterprise RBAC",
      "SSO readiness",
      "Enterprise integrations (roadmap)",
      "CMDB / Jira / ServiceNow / CI/CD integration roadmap",
      "Advanced audit and governance",
      "Custom data retention",
      "Dedicated onboarding and support",
      "Enterprise architecture and modernization governance",
    ],
    cta: "Contact Sales",
    ctaTo: "/contact-sales?plan=enterprise",
    ctaTestId: "pricing-cta-enterprise",
    analytics: "enterprise_contact_started",
    highlight: false,
  },
];

export const SIGNUP_PLAN_OPTIONS = [
  { id: "trial", label: "14-Day Free Trial" },
  { id: "professional", label: "Professional (request access)" },
];

export function planLabel(planId) {
  const match = SIGNUP_PLAN_OPTIONS.find((p) => p.id === planId);
  return match?.label || "14-Day Free Trial";
}

export function normalizeSignupPlan(raw) {
  const key = String(raw || "trial").toLowerCase();
  if (key === "professional") return "professional";
  if (key === "starter" || key === "trial") return "trial";
  return "trial";
}

export const APPLICATION_RANGES = ["<25", "25-100", "101-250", "251-1000", "1000+"];
